export default __webpack_public_path__ + "static/DMMono-Regular-80b88d3e4ce61aa01a4399ff3873f098.eot";